import { IconHeart } from "@/components/icons";
import { useAuth } from "@/contexts/AuthContext";
import { useFavorites } from "@/hooks/use-favorites";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

interface FavoriteButtonProps {
  experienceId: string;
  className?: string;
  size?: "sm" | "md";
}

export function FavoriteButton({ experienceId, className, size = "sm" }: FavoriteButtonProps) {
  const { user } = useAuth();
  const { isFavorite, toggleFavorite } = useFavorites();
  const navigate = useNavigate();
  const active = user ? isFavorite(experienceId) : false;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      navigate("/login");
      return;
    }
    toggleFavorite.mutate(experienceId);
  };

  const iconSize = size === "md" ? "h-5 w-5" : "h-4 w-4";

  return (
    <button
      onClick={handleClick}
      className={cn(
        "rounded-full p-1.5 transition-colors backdrop-blur-sm",
        active
          ? "bg-coral/90 text-white hover:bg-coral"
          : "bg-black/40 text-white/80 hover:bg-black/60 hover:text-white",
        className,
      )}
      aria-label={active ? "Remove from favorites" : "Add to favorites"}
    >
      <IconHeart className={cn(iconSize, active && "fill-current")} filled={active} />
    </button>
  );
}
